import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=0c15f25e&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=js&"
export * from "./FileUpload.vue?vue&type=script&lang=js&"
import style0 from "./Style/file-upload.scss?vue&type=style&index=0&id=0c15f25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15f25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c15f25e')) {
      api.createRecord('0c15f25e', component.options)
    } else {
      api.reload('0c15f25e', component.options)
    }
    module.hot.accept("./FileUpload.vue?vue&type=template&id=0c15f25e&scoped=true&", function () {
      api.rerender('0c15f25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Inputs/FileUpload.vue"
export default component.exports